import { render, staticRenderFns } from "./BlockAbout.vue?vue&type=template&id=28d9a8f6&scoped=true&lang=pug&"
import script from "./BlockAbout.vue?vue&type=script&lang=ts&"
export * from "./BlockAbout.vue?vue&type=script&lang=ts&"
import style0 from "./BlockAbout.vue?vue&type=style&index=0&id=28d9a8f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d9a8f6",
  null
  
)

export default component.exports